import { useEffect, useState } from "react";
import usePagination from "src/components/pagination/usePagination";
import useErrors from "src/hooks/useErrors";
import axiosInstance from "src/utils/fetchUser";

const useFetchWitPagination = (filter, url) => {
  const [data, setData] = useState([]);
  const handleErrors = useErrors();
  const { count, onChange, page, rowStart, seed } = usePagination();
  const fetchData = async (page = 1, filter = {}) => {
    try {
      const { data, status } = await (
        await axiosInstance.get(`${url}`, {
          params: {
            page,
            ...filter,
          },
        })
      ).data;
      if (status) {
        const { data: list, from, last_page } = data;
        seed(last_page, from);
        setData(list);
      }
    } catch (err) {
      handleErrors(err);
    }
  };
  useEffect(() => {
    fetchData(page, filter);
  }, [page]);

  return { data, fetchData, count, onChange, page, rowStart };
};

export default useFetchWitPagination;
